// frontend/src/pages/board/components/details/detailGrid/history/EventDetails.js
import React from "react";
import Avatar from "../../../../../../components/Avatar";
import { createAvtarName, hasImage } from "../../../../../../utils";
import arrow from "../../../../../../styles/svg/arrow.svg";
import { formateDateMMDDYY, parseValueToArrayOrNone } from "../../../../../../utils/helpers";

function EventDetails({ eventType, responseObject, isMobile }) {

  const value = responseObject?.old_key;
  const result = (Array.isArray(value) ? value.length > 0 : value) ? value : "None";

  const customResult = parseValueToArrayOrNone(responseObject?.old_value);
  const customNewResult = parseValueToArrayOrNone(responseObject?.new_value);

  const renderCardAssign = () => (
    <div className="d-flex align-items-center history-heading">
      {responseObject?.old_assignee && (
        <>
          <div className=".history-img">
            <Avatar
              user_image={responseObject?.old_assignee?.user_image}
              className={"history-avatar mr-1"}
              title={responseObject?.old_assignee?.username}
              style={
                !hasImage(responseObject?.old_assignee?.user_image) && {
                  bgcolor:
                    responseObject?.old_assignee?.profile_color?.background,
                  color:
                    responseObject?.old_assignee?.profile_color?.background
                      .text,
                }
              }>
              {createAvtarName(responseObject?.old_assignee?.username)}
            </Avatar>
          </div>
          <p className={isMobile ? "mobile-font" : "mr-4"}>
            {responseObject?.old_assignee?.username}
            {isMobile ? "" : <img className="ml-4" src={arrow} alt="" />}
          </p>
          {isMobile ? <img className="ml-2 mr-2" src={arrow} alt="" /> : ""}
        </>
      )}
      {responseObject?.new_assignee ? (
        <>
          <div>
            <Avatar
              user_image={responseObject?.new_assignee?.user_image}
              className={"history-avatar mr-1"}
              title={responseObject?.new_assignee?.username}
              style={
                !hasImage(responseObject?.new_assignee?.user_image) && {
                  bgcolor:
                    responseObject?.new_assignee?.profile_color?.background,
                  color:
                    responseObject?.new_assignee?.profile_color?.background
                      .text,
                }
              }>
              {createAvtarName(responseObject?.new_assignee?.username)}
            </Avatar>
          </div>
          <p className={isMobile ? "mobile-font" : "mr-4"}>
            {responseObject?.new_assignee?.username}
          </p>
        </>
      ) : (
        <p className={isMobile ? "mobile-font" : "mr-4"}>Unassigned</p>
      )}
    </div>
  );

  const renderChangeStatus = () => (
    <div className="d-flex align-items-center history-heading">
      <div className="old-status-box">
        <p className="old-status">{responseObject?.old_status}</p>
      </div>
      <img className="arrow-img" src={arrow} alt="" />
      <div className="new-status-box">
        <p className="new-status">{responseObject?.new_status}</p>
      </div>
    </div>
  );

  const renderChangeBoard = () => (
    <div className="d-flex align-items-center history-heading">
      <div className="old-status-box">
        <p className="old-status">{responseObject?.old_board}</p>
      </div>
      <img className="arrow-img" src={arrow} alt="" />
      <div className="new-status-box">
        <p className="new-status">{responseObject?.new_board}</p>
      </div>
    </div>
  );

  const renderAllocatedHours = () => (
    <div className="d-flex align-items-center history-heading">
      <div className="old-status-box">
        <p className="old-status">{responseObject?.old_allocated_hours}</p>
      </div>
      <img className="arrow-img" src={arrow} alt="" />
      <div className="new-status-box">
        <p className="new-status">{responseObject?.updated_allcated_hours}</p>
      </div>
    </div>
  )
  const renderParentCard = () => (
    <div className="d-flex align-items-center history-heading">
      <div className="old-status-box">
        <p className="old-status">{responseObject?.old_key || "None"}</p>
      </div>
      <img className="arrow-img" src={arrow} alt="" />
      <div className="new-status-box">
        <p className="new-status">{responseObject?.new_key || "None"}</p>
      </div>
    </div>
  )

  const renderLabelAdded = () => (
    <div className="d-flex align-items-center history-heading">
      {!responseObject?.old_key?.length ? (
        <div className="old-status-box">
          <p className="old-status">None</p>
        </div>
      ) : (
        responseObject?.old_key?.map(label =>
          <div className="old-status-box mr-1">
            <p className="old-status">{label}</p>
          </div>
        )
      )}
      <img className="arrow-img" src={arrow} alt="" />
      {!responseObject?.new_key?.length ? (
        <div className="new-status-box">
          <p className="new-status">None</p>
        </div>
      ) : (
        responseObject?.new_key?.map(label =>
          <div className="new-status-box mr-1">
            <p className="new-status">{label}</p>
          </div>
        )
      )}
    </div>
  )

  const renderCreateComment = () => (
    <div className="d-flex align-items-center history-heading">
      {/* <div className="old-status-box">
        <p className="old-status" dangerouslySetInnerHTML={{ __html: result }}></p>
      </div>
      <img className="arrow-img" src={arrow} alt="" /> */}
      <div>
        <p
          dangerouslySetInnerHTML={{
            __html:
            responseObject?.event_type === "card_log_created"
                ? responseObject?.new_key?.work_performed || ""
                : responseObject?.new_key || ""
          }}
        ></p>
      </div>
    </div>
  )

  const renderUpdateComment = () => (
    <div className="d-flex align-items-center history-heading">
      <div >
        <p dangerouslySetInnerHTML={{ __html: result }}></p>
      </div>
      <img className="arrow-img" src={arrow} alt="" />
      <div>
        <p dangerouslySetInnerHTML={{ __html: responseObject?.new_key }}></p>
      </div>
    </div>
  )
  const renderDeleteComment = () => (
    <div className="d-flex align-items-center history-heading">
      {/* <div className="old-status-box">
        <p className="old-status" dangerouslySetInnerHTML={{ __html: result }}></p>
      </div>
      <img className="arrow-img" src={arrow} alt="" /> */}
      <div>
        <p dangerouslySetInnerHTML={{ __html: result }}></p>
      </div>
    </div>
  )

  const renderDescriptionUpdate = () => (
    <div className="d-flex align-items-center history-heading">
      <div>
        <p dangerouslySetInnerHTML={{ __html: result }}></p>
      </div>
      <img className="arrow-img" src={arrow} alt="" />
      <div>
        <p dangerouslySetInnerHTML={{ __html: responseObject?.new_key }}></p>
      </div>
    </div>
  )

  const renderAttachmentAdded = () => (
    <div className="d-flex align-items-center history-heading">
      <div className="new-status-box">
        <p className="new-status">{responseObject?.new_key}</p>
      </div>
    </div>
  )

  const renderAttachmentDeleted = () => (
    <div className="d-flex align-items-center history-heading">
      <div className="old-status-box">
        <p className="old-status">{result}</p>
      </div>
    </div>
  )

  const renderTitleUpdate = () => (
    <div className="d-flex align-items-center history-heading">
      <div>
        <p>{result}</p>
      </div>
      <img className="arrow-img" src={arrow} alt="" />
      <div>
        <p>{responseObject?.new_key}</p>
      </div>
    </div>
  )

  const renderDueDateUpdate = () => (
    <div className="d-flex align-items-center history-heading">
      <div>
        <p>{result === 'None' ? 'None' : formateDateMMDDYY(result)}</p>
      </div>
      <img className="arrow-img" src={arrow} alt="" />
      <div>
        <p>{formateDateMMDDYY(responseObject?.new_key) || "None"}</p>
      </div>
    </div>
  )

  const renderPriorityUpdate = () => (
    <div className="d-flex align-items-center history-heading">
      <div className="old-status-box">
        <p className="old-status">{result}</p>
      </div>
      <img className="arrow-img" src={arrow} alt="" />
      <div className="new-status-box">
        <p className="new-status">{responseObject?.new_key}</p>
      </div>
    </div>
  )

  const renderCardLogMove = () => (
    <div className="d-flex align-items-center history-heading">
      <div className="old-status-box">
        <p className="old-status">{result}</p>
      </div>
      <img className="arrow-img" src={arrow} alt="" />
      <div className="new-status-box">
        <p className="new-status">{responseObject?.new_key}</p>
      </div>
    </div>
  )

  const renderMovedWorklog = () => (
    <div>
      <div className="d-flex align-items-center history-heading">
        <div className="old-status-box">
          <p className="old-status">{responseObject?.old_key?.[0] + "-" + responseObject?.old_key?.[1]}</p>
        </div>
        <img className="arrow-img" src={arrow} alt="" />
        <div className="new-status-box">
          <p className="new-status">{responseObject?.new_key?.[0] + "-" + responseObject?.new_key?.[1]}</p>
        </div>
      </div>
      <div className="mt-2">
        <p dangerouslySetInnerHTML={{ __html: responseObject?.new_key?.[2] }}></p>
      </div>
    </div>
  )

  const customFieldRender = () => (
    <div className="d-flex align-items-center history-heading">
      <div className="old-status-box">
        <p className="old-status">
          {(() => {
            switch (responseObject?.field_type) {
              case 'date':
                return customResult === 'None' || customResult?.[0] === '0' ? 'None' : formateDateMMDDYY(customResult);
              case 'checkbox':
                return Array.isArray(customResult) ? JSON.parse(customResult).join(', ') : customResult;
              case 'multi_choice':
              case 'select':
              case 'text':
              case 'number':
                return customResult;
              default:
                return customResult;
            }
          })()}
        </p>
      </div>
      <img className="arrow-img" src={arrow} alt="" />
      <div className="new-status-box">
        <p className="new-status">
          {(() => {
            switch (responseObject?.field_type) {
              case 'date':
                return customNewResult === 'None' || customNewResult?.[0] === '0' ? 'None' : formateDateMMDDYY(customNewResult);
              case 'checkbox':
                return Array.isArray(customNewResult) ? JSON.parse(customNewResult).join(', ') : customNewResult;
              case 'multi_choice':
              case 'select':
              case 'text':
              case 'number':
                return customNewResult;
              default:
                return customNewResult;
            }
          })()}
        </p>
      </div>
    </div>
  )

  switch (eventType) {
    case "card_assign":
      return renderCardAssign();

    case "change_status":
      return renderChangeStatus();

    case "change_board":
      return renderChangeBoard();

    case "allocated_hours_update":
      return renderAllocatedHours()

    case "parent_card_update":
      return renderParentCard()

    case "label_added":
      return renderLabelAdded()

    case "label_removed":
      return renderLabelAdded()

    case "create_comment":
      return renderCreateComment()

    case "update_comment":
      return renderUpdateComment()

    case "delete_comment":
      return renderDeleteComment()

    case "description_update":
      return renderDescriptionUpdate()

    case "attachment_added":
      return renderAttachmentAdded()

    case "attachment_deleted":
      return renderAttachmentDeleted()

    case "title_update":
      return renderTitleUpdate()

    case "due_date_update":
      return renderDueDateUpdate()

    case "priority_update":
      return renderPriorityUpdate()

    case "card_log_move":
      return renderCardLogMove()

    case "card_log_created":
      return renderCreateComment()

    case "card_log_deleted":
      return renderDeleteComment()

    case "card_log_updated":
      return renderUpdateComment()

    case "parent_task_relationship_removed":
      return renderAttachmentDeleted()

    case "collaborator_added":
      return renderAttachmentAdded()

    case "collaborator_removed":
      return renderAttachmentDeleted()

    case "card_log_move_from_card":
      return renderMovedWorklog()

    case "custom_field_update":
      return customFieldRender()
    default:
      return null;
  }
}

export default React.memo(EventDetails);
